module.exports = __webpack_public_path__ + "static/fonts/Mont-Thin.afeebec.ttf";